import React from 'react';
import { Container, Grid, Typography, Paper, makeStyles } from '@material-ui/core';
import SettingsIllustration from './SettingsIllustration.png';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { PrimaryButton } from '../../../common/PrimaryButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  paper: {
    display: 'inline-block',
    padding: '23px',
    borderRadius: '8px',
  },
  grantPermissions: {
    fontSize: '16px',
    paddingBottom: '16px',
  },
  /* 
  The size of the image is explicitly stated here so that this content can properly be centered vertically
  before the image is loaded.
  */
  illustration: {
    height: '181px',
    width: '337px',
    '@media screen and (max-width: 800px)': {
      marginTop: '12px',
      width: '50vh',
      height: 'auto',
      maxWidth: '100%',
    },
  },
  gridContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media screen and (max-width: 960px) and (min-width: 761px)': {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    '@media screen and (max-width: 760px)': {
      justifyContent: 'center',
    },
  },
  gridPaper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media screen and (max-width: 960px)': {
      justifyContent: 'center',
    },
    '@media screen and (max-width: 760px)': {
      marginTop: '10px',
    },
  },
  gridItemContainer: {
    '@media screen and (max-width: 960px) and (min-width: 761px)': {
      marginRight: '45px',
    },
  },
});

export function CheckPermissions() {
  const classes = useStyles();
  const { dispatch } = useAppStateContext();
  const { t } = useTranslation('', { keyPrefix: 'DEVICE' });

  const handleClick = async () => {
    try {
      // get audio and video permissions then stop the tracks
      await navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(async (mediaStream) => {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      });
      // The devicechange event is not fired after permissions are granted, so we fire it
      // ourselves to update the useDevices hook. The 100 ms delay is needed so that device labels are available
      // when the useDevices hook updates.
      setTimeout(() => navigator.mediaDevices.dispatchEvent(new Event('devicechange')), 500);
      dispatch({ type: 'next-pane' });
    } catch (error: any) {
      dispatch({ type: 'set-device-error', error });
    }
  };

  return (
    <Container>
      <Grid container className={classes.gridContainer}>
        <Grid item md={6} className={classes.gridItemContainer}>
          <Typography variant="h1" gutterBottom>
            {t('CHECK_PERMISSIONS')}
          </Typography>

          <Typography variant="body1" gutterBottom>
            {t('PERMISSIONS_ACCESS')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>{t('ALLOW_ALL_PERMISSIONS')}</strong>
          </Typography>

          <PrimaryButton onClick={handleClick}>{t('REQUEST_PERMISSIONS')}</PrimaryButton>
        </Grid>

        <Grid item md={5} className={classes.gridPaper}>
          <Paper className={classes.paper}>
            <Typography variant="body1" className={classes.grantPermissions}>
              <strong>{t('GRANT_PERMISSIONS')}</strong>
            </Typography>
            <img src={SettingsIllustration} alt="Settings Illustration" className={classes.illustration} />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
